<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default  {
  name:  'App',
  created(){
  }
}
</script>
<style>
body{
  overflow-y: visible !important;
}
/* 设置滚动条 */
::-webkit-scrollbar {
    width: 4px;
    height: 8px;
}
 
::-webkit-scrollbar-thumb {
    border-radius: 5px;
    -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
    background-color: #99a9bf;
}
 
::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
    border-radius: 5px;
    background-color: #d3dce6;
}
</style>
